import { styled } from '@pata-app/themes';

export const ActionContainer = styled.div`
  display: flex;
  align-self: center;
  gap: ${({ theme }) => theme.core.sizing[2]}px;
  button {
    min-width: 150px;
  }
`;
